import React, { useState } from 'react';
import {Row, Col} from "react-bootstrap";
import ProfileProgress from './ProfileProgress';
import './Profile.css';
import GeneralImg from "../../assets/panelImages/profile/General.jpg";
import PersonalImg from "../../assets/panelImages/profile/Personal.jpg";
import HouseholdImg from "../../assets/panelImages/profile/Household.jpg";
import ProfessionImg from "../../assets/panelImages/profile/Profession.jpg";

const tabData = {
  General: [
    {
      ques: "What is your relationship status?",
      ans_option: ["Single", "Married", "Other", "Prefer not to answer"]
    },
    {
      ques: "Do you have any dependents?",
      ans_option: ["Yes", "No", "Prefer not to answer"]
    },
    {
      ques: "Do you have pets?",
      ans_option: ["Yes", "No", "Prefer not to answer"]
    }
  ],
  Personal: [
    {
      ques: "What is your highest education level?",
      ans_option: ["UnderGraduate", "Graduate", "PostGraduate", "Other", "Prefer not to answer"]
    },
    {
      ques: "Do you have a passport?",
      ans_option: ["Yes", "No", "Prefer not to answer"]
    },
    {
      ques: "What is your birth country?",
      ans_option: ["India", "USA", "Other", "Prefer not to answer"]
    }
  ],
  Household: [
    {
      ques: "Do you rent or own your home?",
      ans_option: ["Rented House", "Own House", "Other", "Prefer not to answer"]
    },
    {
      ques: "How many people live in your household?",
      ans_option: ["Less than 3", "3 or more", "Prefer not to answer"]
    },
    {
      ques: "Do you have internet access at home?",
      ans_option: ["Yes", "No", "Prefer not to answer"]
    }
  ],
  Profession: [
    {
      ques: "What is your current employment status?",
      ans_option: [
        "Full Time",
        "Part Time",
        "Self Employed",
        "Contract, Freelance or Temporary Employee",
        "Homemaker",
        "Retired",
        "Student",
        "Other",
        "Prefer not to answer"
      ]
    },
    {
      ques: "How many years of experience do you have?",
      ans_option: ["Less than 1 year", "1-5 Years", "More than 5 years", "Prefer not to answer"]
    }
  ]
};

const tabImages = {
  General: GeneralImg,
  Personal: PersonalImg,
  Household: HouseholdImg,
  Profession: ProfessionImg
};

const Profile = () => {
  const [activeTab, setActiveTab] = useState("General");
  const [questionIndex, setQuestionIndex] = useState(0);

  const questions = tabData[activeTab];
  const currentQuestion = questions[questionIndex];

  const handleNext = () => {
    if (questionIndex < questions.length - 1) {
      setQuestionIndex(prev => prev + 1);
    }
  };

  const handleBack = () => {
    if (questionIndex > 0) {
      setQuestionIndex(prev => prev - 1);
    }
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setQuestionIndex(0);
  };

  return (
    <div className="mt-2">
      <h2 className="page-main-title">Profile</h2>
      <ProfileProgress />
      <div className="survey-container">
        <div className="tabs">
          {Object.keys(tabData).map((tab) => (
            <div
              key={tab}
              className={`tab profile-tab ${activeTab === tab ? "active" : ""}`}
              onClick={() => handleTabClick(tab)}
            >
              <img src={tabImages[tab]} alt={tab} className="tab-image" />
              <span>{tab}</span>
            </div>
          ))}
        </div>

        <div className="profile-question-box">
          <h4>{currentQuestion.ques}</h4>
          <div className="options">
            <Row>
            {currentQuestion.ans_option.map((option, index) => (
              <Col lg={6} xs={12}>
              <label key={index}>
                <input type="radio" name={`q-${questionIndex}`} required/>
                &nbsp;{option}
              </label>
              </Col>
            ))}
            </Row>
          </div>

          <div className="question-nav">
            <button disabled={questionIndex === 0} onClick={handleBack}>Back</button>
            <button disabled={questionIndex === questions.length - 1} onClick={handleNext} >Next</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
